import { useState } from "react";
import {
  acGasFillProcessSteps,
  acServiceProcessSteps,
  featuredServices,
} from "../data/content";

function FeaturedServicesSection() {
  const [isAcServiceOpen, setIsAcServiceOpen] = useState(false);
  const [isAcGasFillOpen, setIsAcGasFillOpen] = useState(false);

  return (
    <section id="featured" className="section service-showcase">
      <div className="section-title">
        <p>Popular AC Services</p>
        <h2>Visual Service Highlights</h2>
      </div>
      <div className="grid media-grid">
        {featuredServices.map((service) => {
          const isExpandable =
            service.id === "ac-service" || service.id === "ac-gas-fill";

          if (!isExpandable) {
            return (
              <article key={service.title} className="card media-card">
                <img
                  src={`${process.env.PUBLIC_URL}${service.image}`}
                  alt={service.alt}
                  className="card-thumb"
                  loading="lazy"
                />
                <div className="service-meta">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </article>
            );
          }

          const isAcService = service.id === "ac-service";
          const isOpen = isAcService ? isAcServiceOpen : isAcGasFillOpen;
          const setOpen = isAcService ? setIsAcServiceOpen : setIsAcGasFillOpen;
          const processSteps = isAcService
            ? acServiceProcessSteps
            : acGasFillProcessSteps;
          const processId = isAcService
            ? "ac-service-process"
            : "ac-gas-fill-process";
          const processTitle = isAcService
            ? "AC Service 3-Step Process"
            : "AC Gas Fill 3-Step Process";

          return (
            <article
              key={service.title}
              className={`card media-card service-trigger ${isOpen ? "active" : ""}`}
            >
              <button
                type="button"
                className="service-trigger-btn"
                onClick={() => setOpen((prev) => !prev)}
                aria-expanded={isOpen}
                aria-controls={processId}
              >
                <img
                  src={`${process.env.PUBLIC_URL}${service.image}`}
                  alt={service.alt}
                  className="card-thumb"
                  loading="lazy"
                />
                <div className="service-meta">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <span className="tap-hint">
                    {isOpen
                      ? "Hide 3-step process"
                      : "Tap to view 3-step process"}
                  </span>
                </div>
              </button>
              {isOpen && (
                <div id={processId} className="inline-process">
                  <h4>{processTitle}</h4>
                  <div className="grid steps">
                    {processSteps.map((step) => (
                      <article className="card media-card" key={step.title}>
                        <img
                          src={`${process.env.PUBLIC_URL}${step.image}`}
                          alt={step.alt}
                          className="card-thumb step-media"
                          loading="lazy"
                        />
                        <h3>{step.title}</h3>
                        <p>{step.description}</p>
                      </article>
                    ))}
                  </div>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default FeaturedServicesSection;
